import { productCategoryName } from "components/product-category-label";
import { ProductCategory } from "services/types/product-categories.type";

type Categorized = { category?: number | null };

const CATEGORY_GROUP_PREFIX = "category:";
export const UNCATEGORIZED = "Uncategorized";

export function categoryGroupHeading(group: string) {
  return group.startsWith(CATEGORY_GROUP_PREFIX)
    ? group.slice(CATEGORY_GROUP_PREFIX.length)
    : undefined;
}

// MUI's groupBy only merges neighbours, so products are put in the practice's
// category order first, uncategorized last. Array.sort is stable, so the
// catalog's own order holds within a category.
export function sortByCategory<T>(
  products: T[],
  categories: ProductCategory[],
  categoryOf: (product: T) => number | null | undefined = (product) =>
    (product as Categorized).category
) {
  const rank = new Map(
    categories.map((category, index) => [category.id, index])
  );
  const rankOf = (product: T) =>
    rank.get(categoryOf(product) as number) ?? categories.length;
  return [...products].sort((a, b) => rankOf(a) - rankOf(b));
}

export function categoryGroupOf(
  option: Categorized,
  getCategory: (id: number | null | undefined) => ProductCategory | undefined,
  isProduct = true
) {
  if (!isProduct) return "";
  const category = getCategory(option.category);
  return (
    CATEGORY_GROUP_PREFIX +
    (category ? productCategoryName(category) : UNCATEGORIZED)
  );
}
